import { render } from "./google-view.vue?vue&type=template&id=5cba8443"
import script from "./google-view.vue?vue&type=script&lang=js"
export * from "./google-view.vue?vue&type=script&lang=js"

import "./google-view.vue?vue&type=style&index=0&id=5cba8443&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__